import {HTHSymbol, HTHSymbolStates, ISymbolData} from "./HTHSymbol";
import {gsap} from "gsap";
import {HTH} from "../HTH";

export class HTHBlankSymbol extends HTHSymbol {
    private _currentStateSprite: PIXI.Sprite;

    constructor(symbolData: ISymbolData, state: HTHSymbolStates = HTHSymbolStates.BLANK) {
        super(symbolData, state);

        this._currentStateSprite = new PIXI.Sprite();
        this._currentStateSprite.name = "currentStateSprite";
        this._currentStateSprite.anchor.set(0.5, 0.5);
        this._currentStateSprite.position.set(0, 0);
        this.init(symbolData);

    }

    public getSpineAnimation(symData: ISymbolData): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        this.addImage("L5", this.symSize <= 4 ? this.symSize : 5);
        this.symbolState = HTHSymbolStates.BLANK;
        return tl;
    }

    public addImage(textureType: string, textureSize: number): void {
        this._currentStateSprite.texture = HTH.assetLoader.getTextures(`${textureType}/${textureType}_${textureSize}`)[0];
        this._currentStateSprite.visible = false;
        this.addChild(this._currentStateSprite);
    }

    public init(symData: ISymbolData): HTHBlankSymbol {
        this.getSpineAnimation(symData);
        return this;
    }

    public removeAndDestroy(): void {
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.destroy({children: true});
        this.isRemoved = true;
    }
}